import { vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffbcab7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = {
  key: 0,
  class: "dropdown-item"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Loading…", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick", "title"]
const _hoisted_6 = {
  key: 1,
  class: "dropdown-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass({ 'toggled': _ctx.toggled && _ctx.suggestionsCount })
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      ref: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
      placeholder: _ctx.placeholder,
      class: _normalizeClass(["input dropdown-trigger", _ctx.inputClass]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSuggestions && _ctx.toggleSuggestions(...args)), ["stop"])),
      onKeyup: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)), ["stop"])),
      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.check && _ctx.check(...args)))
    }, null, 42, _hoisted_1), [
      [_vModelText, _ctx.input]
    ]),
    (_ctx.toggled && (_ctx.suggestionsCount || _ctx.loading))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["dropdown-content is-paddingless", _ctx.isFixed ? 'is-fixed' : 'is-absolute'])
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion, key) => {
            return (_openBlock(), _createElementBlock("a", {
              key: key,
              onClick: ($event: any) => (_ctx.select(key)),
              title: suggestion,
              class: _normalizeClass([{ 'selected': key === _ctx.current }, "dropdown-item"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hlText(suggestion), (chunk, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass(["is-left", { 'has-text-info': chunk.hl }]),
                  key: index
                }, _toDisplayString(chunk.text), 3))
              }), 128))
            ], 10, _hoisted_5))
          }), 128)),
          (_ctx.count > _ctx.SEARCHABLE_SELECT_MAX_MATCHES)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " and " + _toDisplayString(_ctx.count - _ctx.SEARCHABLE_SELECT_MAX_MATCHES) + " more " + _toDisplayString(_ctx.resultsName), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}